import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const ModalTemplate = ({ title, children, className }) => (
  <Modal className={classNames("min-modal-width", className)} isOpen>
    <ModalHeader tag="h3">{title}</ModalHeader>
    <ModalBody>{children}</ModalBody>
  </Modal>
);

ModalTemplate.propTypes = {
  children: PropTypes.any,
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
};

export default ModalTemplate;
